import React from 'react'
import classnames from 'classnames'
import { PROFILE_CONTAINER, PROFILE_CONTAINER_STYLES } from 'components/AuthModal/styles'

const Form = ({ onSubmit, children }) => (
  <form
    noValidate
    onSubmit={onSubmit}
    className={classnames(PROFILE_CONTAINER, 'justify-between bg-cover bg-no-repeat')}
    style={PROFILE_CONTAINER_STYLES}
  >
    {children}
  </form>
)

export default Form
